
export default [
  '04h00',
  '04h05',
  '04h10',
  '04h15',
  '04h20',
  '04h25',
  '04h30',
  '04h35',
  '04h40',
  '04h45',
  '04h50',
  '04h55',
  //
  '05h00',
  '05h05',
  '05h10',
  '05h15',
  '05h20',
  '05h25',
  '05h30',
  '05h35',
  '05h40',
  '05h45',
  '05h50',
  '05h55',
  //
  '06h00',
  '06h05',
  '06h10',
  '06h15',
  '06h20',
  '06h25',
  '06h30',
  '06h35',
  '06h40',
  '06h45',
  '06h50',
  '06h55',
  //
  '07h00',
  '07h05',
  '07h10',
  '07h15',
  '07h20',
  '07h25',
  '07h30',
  '07h35',
  '07h40',
  '07h45',
  '07h50',
  '07h55',
  //
  '08h00',
  '08h05',
  '08h10',
  '08h15',
  '08h20',
  '08h25',
  '08h30',
  '08h35',
  '08h40',
  '08h45',
  '08h50',
  '08h55',
  //
  '09h00',
  '09h05',
  '09h10',
  '09h15',
  '09h20',
  '09h25',
  '09h30',
  '09h35',
  '09h40',
  '09h45',
  '09h50',
  '09h55',
  //
  '10h00',
  '10h05',
  '10h10',
  '10h15',
  '10h20',
  '10h25',
  '10h30',
  '10h35',
  '10h40',
  '10h45',
  '10h50',
  '10h55',
  //
  '11h00',
  '11h05',
  '11h10',
  '11h15',
  '11h20',
  '11h25',
  '11h30',
  '11h35',
  '11h40',
  '11h45',
  '11h50',
  '11h55',
  //
  '12h00',
  '12h05',
  '12h10',
  '12h15',
  '12h20',
  '12h25',
  '12h30',
  '12h35',
  '12h40',
  '12h45',
  '12h50',
  '12h55',
  //
  '13h00',
  '13h05',
  '13h10',
  '13h15',
  '13h20',
  '13h25',
  '13h30',
  '13h35',
  '13h40',
  '13h45',
  '13h50',
  '13h55',
  //
]



// WEBPACK FOOTER //
// ./src/utils/horairesPossibles.js